module.exports = __webpack_public_path__ + "static/media/welcome-all-dogs.102a245b.gif";